import EventEmitter from "../../utils/eventEmitter";
import Axios from "../utils/axios";



export const loadExpenseCategories = async () => {
  try {
    const response = await Axios.get('/expensecategories');
    const responseData = await response.data;
    return responseData;
  }catch (err) {
    throw err;
  }
};



export const loadExpenseCategory = async (action) => {
  try {
    switch (action) {
      case 'new':
        const response = await Axios.get('/setups/expensecategories');
        const requestData = await response.data;
        return {...requestData, expenseCategory: {}};
        
      default:
        const respnse = await Axios.get('/expensecategories/find/'+action);
        const responseData = await respnse.data;
        return responseData;
    }
  }catch (err) {
    throw err;
  }
}

const useExpenseCategoryAPI = () => {
  
  const create = async (data, success) => {
    try {
      const respnse = await Axios.post('/expensecategories', data);
      const responseData = await respnse.data;
      success(responseData.message);
      EventEmitter.dispatch('expensecategories', data.seo);
    }catch(err) {
      throw err;
    }
  }

  const update = async (seo, data, success) => {
    try {
      const respnse = await Axios.put('/expensecategories/'+seo, data);
      const responseData = await respnse.data;
      success(responseData.message);
      EventEmitter.dispatch('expensecategories', data.seo);
    }catch (err) {
      throw err;
    }
  }


  return { create, update };
};



export default useExpenseCategoryAPI;


